// JS for your graphic
import pym from "pym.js";
import d3tip from "d3-tip";
import schools from "../data/feederschools.csv";
import L from "leaflet";
import {select, csv} from "d3";

// let width = d3.min([300, window.innerWidth]);
// let height = width;
// let margin = { top: 0, right: 0, bottom: 0, left: 0 };

const coords = {
  detroit: [42.47209690919285, -83.42468261718749],
  tristate: [40.74725696280421, -74.124755859375],
};

let map = L.map("graphic", {
  zoomControl: false,
  dragging: false,
  scrollWheelZoom: false,
  boxZoom: false,
  doubleClickZoom: false,
  touchZoom: false,
}).setView(coords.detroit, 8);
map.dragging.disable();
// map.zoomControl.disable();

L.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
  attribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  subdomains: "abcd",
  minZoom: 8,
  maxZoom: 8,
}).addTo(map);

const draw = ([data]) => {
  const tip = d3tip()
    .attr("class", "d3-tip")
    .offset([-5, 0])
    .html(
      (d) => `${d.school}, ${d.state}<br><br>
                  Applications: ${d.apply}<br>
                  Admissions: ${d.admit}<br>
                  Enrollment: ${d.enroll}`
    );

  const mapEl = select("#graphic").node();
  const svg = select(map.getPanes().overlayPane)
    .append("svg")
    .attr("width", mapEl.clientWidth)
    .attr("height", mapEl.clientHeight);
  const g = svg.append("g").attr("class", "leaflet-zoom-hide");

  g.call(tip);

  g.selectAll("rect.map__school")
    .data(data.filter((d) => !!(d.lng && d.lat)))
    .join("rect")
    .attr("class", "map__school")
    .attr("width", 6)
    .attr("height", 6)
    .attr("fill", "#374567")
    .attr(
      "transform",
      (d) =>
        `translate(${
          map.latLngToLayerPoint(new L.LatLng(d.Latitude, d.Longitude)).x - 3
        }, ${
          map.latLngToLayerPoint(new L.LatLng(d.Latitude, d.Longitude)).y - 3
        })`
    )
    .on("mouseover", function (_, d) {
      select(this).raise();
      tip.show(
        {
          school: d.School,
          state: d.State,
          apply: d.Applications,
          admit: d.Admitted,
          enroll: d.enrolled,
          // offsetX: d.x0 == 2,
        },
        this
      );
    })
    .on("mouseover", function (_, d) {
      select(this).raise();
      tip.show(
        {
          school: d.School,
          state: d.State,
          apply: d.Applications,
          admit: d.Admitted,
          enroll: d.enrolled,
          // offsetX: d.x0 == 2,
        },
        this
      );
    })
    .on("mouseclick", function (_, d) {
      select(this).raise();
      tip.show(
        {
          school: d.School,
          state: d.State,
          apply: d.Applications,
          admit: d.Admitted,
          enroll: d.enrolled,
          // offsetX: d.x0 == 2,
        },
        this
      );
    })
    .on("touchstart", function (_, d) {
      select(this).raise();
      tip.show(
        {
          school: d.School,
          state: d.State,
          apply: d.Applications,
          admit: d.Admitted,
          enroll: d.enrolled,
          // offsetX: d.x0 == 2,
        },
        this
      );
    })
    .on("mouseleave", tip.hide);
  // .on("mouseover", (e, d) => {
  //   let xVal = e.offsetX + 5;
  //   if (width - xVal < 150) {
  //     xVal = e.offsetX - 150 - 5;
  //   }
  //   const fmt = d3.format(".0f");
  //   d3
  //     .select(".tooltip")
  //     .style("opacity", 1)
  //     .style("top", e.offsetY + "px")
  //     .style("left", xVal + "px").html(`
  //       <span class="school-name">${d.School}</span> <br />
  //       <b>${d.apps}</b> applied <br />
  //       <b>${d.admits}</b> admitted (${fmt(
  //     (d.admits / d.apps) * 100
  //   )} percent) <br />
  //       <b>${d.enrolled}</b> enrolled (${fmt(
  //     (d.enrolled / d.admits) * 100
  //   )} percent) <br />
  //       `);
  // })
  // .on("mouseout", () => {
  //   d3.select(".tooltip").style("opacity", 0);
  // });
};

const resize = () => {};

window.onload = function () {
  const pymChild = new pym.Child({ renderCallback: resize, polling: 500 });
  pymChild.sendHeight();

  Promise.all([
    csv(schools).then((d) => {
      d.forEach((d) => {
        d.aps = d["# of APs"];
        d.americanIndian = d["% American Indian"];
        d.lat = +d.Latitude;
        d.lng = +d.Longitude;
        d.apps = +d.Applications;
        d.admits = +d.Admitted;
        d.enrolled = +d["Enrolled at UM"];
        d.income = +d["Median Income"];
      });
      return new Promise((res) => res(d));
    }),
  ]).then((schools, topo) => {
    draw(schools, topo);
  });
};
